export class ReportAppLeftPanelClasses {

    static readonly root = "ic3ReportAppLeftPanel-root";

    static readonly menu = "ic3ReportAppLeftPanel-menu";

    static readonly title = "ic3ReportAppLeftPanel-title";

    static readonly filter = "ic3ReportAppLeftPanel-filter";

}

export declare type ReportAppLeftPanelClassKey = keyof ReportAppLeftPanelClasses;
